export default __webpack_public_path__ + "static/media/UTPL Financials 2021.5411eaa4.pdf";